import { FC, ReactNode } from 'react'

type ConditionalWrapperProps<Props> = {
  condition: boolean
  wrapper: FC<Props>
  wrapperProps: Props
  children: ReactNode
}

export const ConditionalWrapper = <Props,>({
  condition,
  wrapper: Wrapper,
  wrapperProps,
  children
}: ConditionalWrapperProps<Props>) =>
  condition ? <Wrapper {...wrapperProps}>{children}</Wrapper> : children
